export default {
    show: 'إظهار',
    'archived': 'مؤرشفة',
    'revolved': 'مدورة',
    'locked': 'مقفلة',
    'active': 'فعالة',
    'no-$-financial-files': 'لا يوجد ملفات مالية {state}',

    'revolved-to-$': 'مدور إلى  "{financialFile}"',
}